var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 37 38"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36.458,
    height: 36.458,
    x: 0.125,
    y: 0.792,
    fill: "#000",
    fillOpacity: 0.5,
    rx: 18.229
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m21.516 13.757 1.051-1.051a1.487 1.487 0 0 1 2.103 2.103l-1.051 1.05m-2.103-2.102-3.925 3.926c-.784.784-1.176 1.176-1.443 1.653s-.536 1.606-.793 2.685c1.079-.257 2.207-.526 2.685-.793.477-.267.87-.659 1.653-1.443l3.926-3.925m-2.103-2.103 2.103 2.103"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M25.106 19.02c0 3.183 0 4.774-.989 5.762s-2.58.988-5.762.988-4.773 0-5.761-.988-.989-2.58-.989-5.762 0-4.772.989-5.761 2.58-.989 5.762-.989"
  })));
};
export default SvgEdit;